import React, { useEffect, useState } from "react";

export default function AuditHaccpHistory({ refreshKey = 0 }) {
    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState([]);
    const [err, setErr] = useState(null);

    useEffect(() => {
        let alive = true;

        (async () => {
            setLoading(true);
            setErr(null);
            try {
                const r = await fetch("/api/audit_haccp_list.php", { credentials: "include" });
                const j = await r.json();
                if (!j.success) throw new Error(j.error || "Errore caricamento storico");
                if (alive) setItems(j.items || []);
            } catch (e) {
                if (alive) setErr(e.message || "Errore");
            } finally {
                if (alive) setLoading(false);
            }
        })();

        return () => {
            alive = false;
        };
    }, [refreshKey]);

    return (
        <div className="mb-6 rounded-2xl shadow bg-white overflow-hidden">
            <div className="px-4 py-3 border-b flex items-center justify-between">
                <h2 className="font-semibold">Storico Audit di Controllo</h2>
                <div className="text-xs opacity-70">Ultimi 100</div>
            </div>

            {loading && <div className="p-4 text-sm">Caricamento...</div>}

            {!loading && err && (
                <div className="p-4 text-sm bg-red-50">
                    Errore: {err}
                </div>
            )}

            {!loading && !err && items.length === 0 && (
                <div className="p-4 text-sm opacity-80">
                    Nessun audit salvato ancora.
                </div>
            )}

            {!loading && !err && items.length > 0 && (
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="p-3 text-left">Data</th>
                                <th className="p-3 text-left">Verificatore</th>
                                <th className="p-3 text-center">Non Conforme</th>
                                <th className="p-3 text-center">PDF</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((a) => {
                                const nc = Number(a.nc_count || 0);
                                return (
                                    <tr key={a.id} className="border-t">
                                        <td className="p-3">{a.data_verifica}</td>
                                        <td className="p-3">{a.verificatore}</td>
                                        <td className={`p-3 text-center font-semibold ${nc > 0 ? "text-red-600" : "text-green-600"}`}>
                                            {nc}
                                        </td>
                                        <td className="p-3 text-center">
                                            {/* Questo endpoint lo aggiungiamo dopo: per ora lasciamo il link pronto */}
                                            <a
                                                className="px-3 py-1 rounded-lg border inline-block"
                                                href={`/api/audit_haccp_pdf.php?id=${a.id}`}
                                                target="_blank"
                                                rel="noreferrer"
                                                title="Apri PDF (se endpoint presente)"
                                            >
                                                📄
                                            </a>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
